import React from 'react';
import styles from './styles/bot-message.module.css';
import PropTypes from 'prop-types';
import { addAnswer, skipBlock } from '@/store/slices/chatbotFlow';
import { connect } from 'react-redux';
import InputTypes from '@/constants/InputTypes';
import MultipleSelectOptions from '@/components/chatbot/Layout/messages/MultipleSelectOptions';
import Geolocation from '@/components/chatbot/Layout/messages/Geolocation';
import PaginatedOptions from '@/components/chatbot/Layout/messages/PaginatedOptions';
import { linkInTextRegex, linkRegex, encodeQueryParams } from '@/helpers/linkParser';

const BotMessage = props => {

  function renderAnswers() {
    const { block, isActive } = props;
    if (block.inputType === InputTypes.MULTIPLE_SELECT_OPTIONS) {
      return <MultipleSelectOptions block={block} isActive={isActive} />;
    } else if (block.inputType === InputTypes.GEOLOCATION) {
      return <Geolocation addAnswer={props.addAnswer} block={block} />;
    } else if (block.inputType === InputTypes.OPTIONS) {
      return <PaginatedOptions block={block} />;
    } else if (block.inputType === InputTypes.USER_TYPE) {
      return (
        <>
          {block?.options?.none?.enabled === true && (
            <span
              className={styles.renderAnswers}
              onClick={() => props.addAnswer(block?.options?.none)}
            >
              {block?.options?.none?.title}
            </span>
          )}
          {block?.options?.candidate?.enabled === true && (
            <span
              className={styles.renderAnswers}
              onClick={() => props.addAnswer(block?.options?.candidate)}
            >
              {block?.options?.candidate?.title}
            </span>
          )}
          {block?.options?.client?.enabled === true && (
            <span
              className={styles.renderAnswers}
              onClick={() => props.addAnswer(block?.options?.client)}
            >
              {block?.options?.client?.title}
            </span>
          )}
        </>
      );
    } else if (block.inputType === InputTypes.JOB_TYPE) {
      return (
        <>
          {block?.options?.permanent?.enabled === true && (
            <span onClick={() => props.addAnswer(block?.options?.permanent)}>
              {block?.options?.permanent?.title}
            </span>
          )}
          {block?.options?.temporary?.enabled === true && (
            <span onClick={() => props.addAnswer(block?.options?.temporary)}>
              {block?.options?.temporary?.title}
            </span>
          )}
          {block?.options?.contract?.enabled === true && (
            <span onClick={() => props.addAnswer(block?.options?.contract)}>
              {block?.options?.contract?.title}
            </span>
          )}
        </>
      );
    } else if (block.inputType === InputTypes.GENDER) {
      return (
        <>
          {block?.options?.answers?.map(option => (
            <span
              key={option.id}
              className={styles.renderAnswers}
              onClick={() => props.addAnswer(option)}
            >
              {option.title}
            </span>
          ))}
        </>
      );
    }
  }

  function renderTextWithLinks(string) {
    if (!string) return <span />;
    const links = string.match(linkInTextRegex);
    const texts = string.replace(linkInTextRegex, ' (^_^) ').split(' (^_^) ');

    return (
      <span>
        {texts.map((item, i) => {
          let render = <span key={i}>{item}</span>;
          if (links && i !== texts.length - 1) {
            const parsedLink = links[i]?.match(linkRegex);
            if (parsedLink) {
              const [full, text, url] = parsedLink;
              const href = encodeQueryParams(url);

              render = (
                <span key={i}>
                  {item}{' '}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={href}
                  >
                    {text}
                  </a>
                </span>
              );
            } else {
              render = (
                <span key={i}>
                  {item} {links[0]}
                </span>
              );
            }
          }
          return render;
        })}
      </span>
    );
  }

  return (
    <div className={styles.main_wrapper}>
      <div className={`${styles.full_wrapper} centeredContent`}>
        <div
          style={{
            backgroundColor: props.settings?.bot?.messageBackgroundColor,
            color: props.settings?.bot?.messageTextColor,
          }}
          className={`${styles.wrapper}`}
        >
          <span className={styles.messageText}>
            {renderTextWithLinks(props.block.message)}
          </span>
          {props.isActive && (
            <div className={styles.answers}>
              {renderAnswers()}
              {props.block?.skip?.enabled === true && (
                <span className={styles.skip} onClick={() => props.skipBlock()}>
                  {props.block.skip.text || 'Skip'}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

BotMessage.propTypes = {
  block: PropTypes.object,
  isActive: PropTypes.bool.isRequired,
  afterMessage: PropTypes.bool,
};

const mapDispatchToProps = { addAnswer, skipBlock };
const mapStateToProps = state => ({
  settings: state.chatbotDetails.settings,
  state: state,
});
export default connect(mapStateToProps, mapDispatchToProps)(BotMessage);
